var tag = document.createElement('script');

tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

SE.clsVideo = (function () {
  var video = $("video").get(0);

  // console.log(witdh_video*9/16);
  //INIT
  function init() {
    initEvent();
    console.log("clsVideo - init");
  }

  function initEvent() {
    createHeigh();
    createVideo();
    playVideo();
    pauseVideo();
  }



  //FUNCTIONS
  function playVideo() {
    $(".play-custom").click(function () {
      video.play();
      $(this).hide();
    });
  }

  function pauseVideo() {
    $("video").click(function () {
      video.pause();
      $(".play-custom").show();
    });
  }

  function createHeigh() {
    var witdh_video = $('.video-inner').width();
    var heigh_video = witdh_video*9/16;
    $('.video-inner').css('height', heigh_video);

    $( window ).resize(function() {
      var witdh_video = $('.video-inner').width();
      var heigh_video = witdh_video*9/16;
      $('.video-inner').css('height', heigh_video);
    });

  }

  function createVideo() {
    var idYt_para = {
      id: 'SNES5Y-tYxM'
    }

    $('.video-inner').append('<iframe id="player" type="text/html" src="http://www.youtube.com/embed/'+ idYt_para.id  +'?autoplay=1&mute=0" frameborder="0" allowfullscreen></iframe>')
  }



  //RETURN
  return {
    init: init,
    createHeigh
  };
})();
// SE.clsVideo.init();
